import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between w-full text-gray-400" }
const _hoisted_2 = { class: "flex flex-row items-center w-1/3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Showing", -1)
const _hoisted_4 = { class: "bg-gray-200 rounded p-2 mx-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "of", -1)
const _hoisted_6 = { class: "bg-gray-200 rounded p-2 mx-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "results", -1)
const _hoisted_8 = { class: "flex justify-center w-1/3" }
const _hoisted_9 = { class: "flex flex-row items-center justify-end w-1/3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Go to page", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.from) + " - " + _toDisplayString(_ctx.to), 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.total), 1),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_pagination, {
        modelValue: _ctx.page,
        pages: _ctx.pages,
        "range-size": _ctx.rangeSize,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:modelValue', e))
      }, null, 8, ["modelValue", "pages", "range-size"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("select", {
        value: _ctx.page,
        onInput: _cache[1] || (_cache[1] = (e) => _ctx.$emit('update:modelValue', e.target.value)),
        class: "bg-gray-200 rounded p-2 ml-2"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: i
          }, _toDisplayString(i), 9, _hoisted_12))
        }), 128))
      ], 40, _hoisted_11)
    ])
  ]))
}